import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import CardInfo from '../../../../components/CardInfo/CardInfo'
import EditAction from '../EditAction'
import { useFormik } from 'formik'
import { getInitialValues } from '../../../../forms/LocationPreferencesForm'
import CheckBox from '../../../../components/CheckBox/CheckBox'
import { isEmpty, isNil } from 'ramda'

const LocationPreferences = ({ user, shiptos, handleSubmit }) => {
    const [isEnabledPL, setisEnabledPL] = useState(false)
    const userLocationsPreferences = user?.locationPreferences

    const initialValues = getInitialValues(shiptos, userLocationsPreferences)

    const {
        isSubmitting,
        setSubmitting,
        isValid,
        handleSubmit: onSubmitForm,
        values,
        setFieldValue,
        setValues,
    } = useFormik({
        initialValues: initialValues,
        onSubmit: formValues => {
            setSubmitting(true)
            const formattedFormValues = Object.keys(formValues).map(key => {
                if (formValues[key] === true) {
                    return `${key}`
                }
                return null
            })
            const locations = formattedFormValues?.filter(
                i => !isNil(i) && i != 'all',
            )
            handleSubmit &&
                handleSubmit({ locationPreferences: locations }).then(() => {
                    setSubmitting(false)
                    setisEnabledPL(false)
                })
        },
    })

    useEffect(() => {
        if (!isEmpty(shiptos)) {
            setValues(getInitialValues(shiptos, userLocationsPreferences))
        }
        return () => {
            setValues({})
        }
    }, [shiptos])

    const hasDiferences =
        JSON.stringify(values) !== JSON.stringify(initialValues)

    useEffect(() => {
        // to restart the initial value if the user cancelthe edit
        if (!isEnabledPL) {
            Object.keys(initialValues)?.forEach(item => {
                setFieldValue(item, initialValues[item])
            })
            setFieldValue('all', initialValues['all'])
        }
    }, [isEnabledPL])

    const checkAll = (key, newVal) => {
        const newValues = {
            ...values,
            [key]: newVal,
        }
        const checkedNewValues =
            Object.keys(newValues)?.filter(
                item => item != 'all' && newValues[item] === true,
            ) || []
        if (checkedNewValues?.length === shiptos?.length) {
            setFieldValue('all', true)
        } else {
            setFieldValue('all', false)
        }
    }

    const renderForm = () => {
        return (
            <div className="w-full flex flex-col gap-y-6 items-start justify-start">
                <div>
                    <h2 className="text-textDarkerGray font-medium text-sm">
                        Your locations
                    </h2>
                    <p className="text-textDarkGray font-normal text-xs mt-1">
                        Choose the locations that you’d like to be up to date
                        with
                    </p>
                </div>

                <CheckBox
                    key={`$all-location`}
                    label={'All Locations'}
                    description={null}
                    defaultChecked={values['all']}
                    defaultValue={false}
                    correctValue={true}
                    disabled={!isEnabledPL}
                    onChange={val => {
                        shiptos?.forEach(item => {
                            setFieldValue(item?.id, val)
                        })
                        setFieldValue('all', !values['all'])
                    }}
                />

                {shiptos?.map(s => {
                    return (
                        <CheckBox
                            key={`${s?.id}-location`}
                            label={s?.label}
                            extraLabel={s?.sap_id}
                            description={s?.address}
                            defaultChecked={values[s?.id]}
                            defaultValue={false}
                            correctValue={true}
                            disabled={!isEnabledPL}
                            onChange={val => {
                                setFieldValue(s?.id, val)
                                checkAll(s?.id, val)
                            }}
                        />
                    )
                })}
            </div>
        )
    }

    return (
        <form onSubmit={onSubmitForm} className="w-full">
            <CardInfo
                title="Location Preferences"
                content={renderForm()}
                headerActions={[
                    <EditAction
                        setEnabled={setisEnabledPL}
                        isValid={
                            isValid &&
                            !isSubmitting &&
                            isEnabledPL &&
                            hasDiferences
                        }
                        key="editButton"
                    />,
                ]}
            />
        </form>
    )
}

LocationPreferences.propTypes = {
    shiptos: PropTypes.arrayOf(PropTypes.object),
    handleSubmit: PropTypes.func,
    user: PropTypes.object,
}

export default LocationPreferences
